import * as React from "react"

function DIGITAL_SERVICES_BG({props}) {
  return (
    <svg
      width={923}
      height={779}
      viewBox="0 0 923 779"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M923.093 778.86C820.48 729.36 717.867 680.04 604.8 648.54c-113.28-31.32-236.8-44.82-331.947-99.9C177.707 493.38 111.147 396.36 70.4 298.08 29.653 199.62 14.933 99.9 0 0h923.093v778.86z"
        fill="#DFDEF2"
      />
      <path
        d="M923.093 389.34c-51.413-24.66-102.613-49.32-159.146-64.98-56.534-15.84-118.4-22.5-165.974-50.04-47.573-27.54-80.853-76.14-101.333-125.28C476.373 99.9 468.907 49.86 461.653 0h461.44v389.34z"
        fill="#ECCBD9"
      />
    </svg>
  )
}

export default DIGITAL_SERVICES_BG





export function VTU_PAY({props,color}) {
  return (
    <svg
    // className="absolute w-[100%]" viewBox="0 0 0 319"
       width={380}
       height={319}
       viewBox="0 0 380 319"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M380 318.279c-29.03-21.331-57.973-42.736-82.819-57.521-24.759-14.859-45.42-23.097-77.153-26.995-31.733-3.825-74.711-3.237-92.757-20.523-18.046-17.285-11.246-52.519-29.64-75.689-18.395-23.171-61.984-34.278-81.948-55.168C-4.368 61.42-.794 30.747 2.78 0H380v318.279z"
        fill={color}
      />
    </svg>
  )
}




export function EMAIL_MARKETING_BG({props,width,height}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 771 533"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
     
      <path
        opacity={0.18}
        d="M131.301 61c-24.34 5.16-49.64 10.76-69.18 26.17-16.5 13-42.21 37-50 56.5-33 82.37 4.31 182.6 76.73 233.86 34.06 24.11 76.51 35.78 107.12 64.16 19.36 17.95 32.92 41.71 53.52 58.21 30.1 24.09 70.74 29.42 109.2 32 26.72 1.81 54.48 2.59 79.27-7.57 17.92-7.34 33.1-19.93 48-32.34l98.71-82.43c15.86-13.23 30.69-34.3 51.34-34.16 185.86 1.33 198.39-217.4-86.86-314.28-25.14-8.54-42.38-32.28-66-44.45-48.79-25.15-104.94-17-154.15.4-62.48 22.15-132.86 30.14-197.7 43.93z"
        fill="#68E1FD"
      />
      
    </svg>
  )
}







// CARD ISSUING BG 
 